<div class="half-page card-one scrollable-container">
  <div class="row orderStatus-Header">
    <div class="col-md-12 top-margin2">
      <label class="header-content"><b>Status:</b> {{ currentStatus }} on {{ lastModifiedDate }}</label>
    </div>
  </div>
  <div style="margin: 2% 1% 0% 1%;">
    <mat-accordion>
      <div *ngFor="let order of orderStatuses">
          <mat-expansion-panel [disabled]="!(order.isCompleted || order.isEditable)">

            <!-- Panel Header -->
            <mat-expansion-panel-header>
              <mat-card class="order-card"   [id]="'order-card-' + order.status" [ngClass]="{ 'completed': order.isCompleted }">
                <mat-card-title>
                  <mat-icon class="status-icon"
                    [ngClass]="{ 'completed-icon': !order.isCompleted, 'completed-icon': order.isCompleted }">
                    {{ order.isCompleted ? 'check_circle' : 'sync' }}
                  </mat-icon>
                  <span class="status-tittle">{{ order.displayName }}</span>
                </mat-card-title>
              </mat-card>
            </mat-expansion-panel-header>

            <!-- Panel Body -->
            <mat-card-content class="status-content" [id]="'status-content-' + order.status">
              <div class="notes-header">
                <p class="label">Notes:</p>
                <button *ngIf="order.isCompleted " [id]="'edit-icon-' + order.status" class="edit-icon-button" 
                title="Edit"
                (click)="onEditNotes(order)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
              <p *ngIf="order.isCompleted && !isEditableValueMap[order.statusId]" class="note-text">{{ order.notes }}</p>
              <jqxTextArea *ngIf="!order.isCompleted || isEditableValueMap[order.statusId]" 
               aria-hidden="true" #notesComponent 
               [(ngModel)]="textAreaValueMap[order.statusId]"
               [width]="'99%'" 
               [height]="80"
               [attr.id]="'textarea-' + order.status"
               maxLength=1000 style="border-radius: 12px;">
              </jqxTextArea>
              <div class="date-status-row">
                <div *ngIf="order.isCompleted; else datePickerTemplate">
                  <p class="label">{{ order.createdTime}}</p>
                </div>
                <ng-template #datePickerTemplate>
                  <p class="label"></p>
                  <!-- <jqxDateTimeInput #dateTimeInput id="myDateTimeInput" [(ngModel)]="defaultSelectedDate" 
                  [width]="200" [height]="28"
                    [formatString]="'dd-MMM-yyyy'" theme="material"
                    (onValueChanged)="onDateValueChanged($event)"
                    style="border-color: #007bff; border-radius: 20px; padding: 5px 10px; font-size: 14px; background-color: #f0f8ff; color: #007bff; margin-left: 1%;">
                  </jqxDateTimeInput> -->
                </ng-template>
                <span *ngIf="order.isCompleted && !isEditableValueMap[order.statusId]" class="status">
                  <span class="label">Status:</span>
                  <span [ngClass]="{ 'completed-text': order.isCompleted }">
                    {{ order.isCompleted ? 'Completed' : 'In Progress' }}
                  </span>
                </span>
                <div class="edit-actions"  *ngIf="!order.isCompleted || isEditableValueMap[order.statusId]">
                  <button mat-icon-button class="edit-btn update" title="Update" (click)="updateOrder(order)">
                    <mat-icon color="primary">check_circle</mat-icon>
                  </button>
                
                  <button mat-icon-button class="edit-btn reject" title="Reject" (click)="rejectOrder(order)">
                    <img src="../../../assets/img/icon/reject_icon.png" alt="Reject"/>
                    <!-- <mat-icon color="warn">cancel</mat-icon> -->
                  </button>
                
                  <button mat-icon-button class="edit-btn cancel" title="Cancel" (click)="cancel()">
                    <mat-icon>close</mat-icon>
                  </button>
                  <!-- <button class="update-button" (click)="updateOrder(order)">Update</button> -->
                </div>
              </div>
            </mat-card-content>
          </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
</div>
<jqxNotification #msgNotification [position]="'top-right'" [opacity]="1.0" [autoOpen]="false"
    [autoClose]="true" [animationOpenDelay]="800" [autoCloseDelay]="5000" template.success>
</jqxNotification>